<template>
    <div>
        <h1>Contacto</h1>
    </div>
</template>